import React from 'react'
import { FaHammer, FaShoppingBag, FaConciergeBell } from 'react-icons/fa'
import sampleImg from '../../assets/image19.png'

const industries = [
    {
        icon: <FaHammer />,
        title: 'Trade & Construction Suppliers',
        desc: 'Deliver materials and tools directly to job sites, reducing downtime for your clients.',
    },
    {
        icon: <FaShoppingBag />,
        title: 'Retail & eCommerce',
        desc: 'Boost conversion rates by offering same-day and next-day delivery options.',
    },
    {
        icon: <FaConciergeBell />,
        title: 'Hospitality & Events',
        desc: 'Ensure venues and caterers receive supplies right when they need them.',
    },
]

const IndustriesWeServe = () => {
    return (
        <section className="py-14 md:py-24 px-4 bg-white">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-20">
                {/* Left Image */}
                <div className="w-full">
                    <img
                        src={sampleImg}
                        alt="Industries"
                        className="w-full rounded-xl object-cover"
                    />
                </div>

                {/* Right Text */}
                <div className="w-full flex flex-col justify-center">
                    <h2 className="text-3xl md:text-4xl font-bold text-headings mb-4">
                        Industries We Serve
                    </h2>

                    <p className="text-light_black max-w-[500px] w-full mb-10">
                        Tuber supports a wide range of businesses, ensuring fast, safe, and reliable deliveries across multiple industries:
                    </p>

                    <div className="space-y-6">
                        {industries.map((item, idx) => (
                            <div key={idx} className="flex gap-5 items-center">
                                <div className='text-primary w-12 h-12 rounded-full flex items-center justify-center text-xl bg-gray_light'>
                                    {item.icon}
                                </div>

                                <div className='flex-1 max-w-[400px] w-full'>
                                    <h4 className="text-lg font-semibold text-headings">{item.title}</h4>
                                    <p className="text-sm text-light_black">{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default IndustriesWeServe
